<template>
    <div>
        <apexcharts
        ref="barchart"
        width="100%"
        height="380"
        type="pie"
        :options="options"
        :series="options.series"
        ></apexcharts>
        <div class="block">
            <div align="center">Necessidade de Cobertura Atual</div>
            <div class="total" align="center">Total: {{this.saldo}}</div>
        </div>
    </div>
</template>

<script>
    import ApexCharts from 'apexcharts'
    import VueApexchar from 'vue-apexcharts'
    import { get } from "@/helpers/api";
    import { utils } from "../relatorios/mixins/index";
    export default {
        name:'NecessidadeCoberturaAtual',
        mixins: [utils],
        components: {
            'apexcharts': VueApexchar
        },
        data () {
            return {
                db:[],
                options: {},
                seguro:[],
                resumo:[],
                saldo:null
            }
        },
        methods:{
            async plot(){

                if (! this.$refs.barchart) return '';

                await this.$refs.barchart.chart.dataURI().then(uri => {
                    this.image = uri || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=';
                });

                return `<div>
                            <img src="${this.image}" />
                            <div align="center">Necessidade de Cobertura Atual</div>
                            <div style="font-size: 12px;" align="center">
                                Total: ${this.saldo}
                            </div>
                        </div>`;
            },
            jsonToObject(j){
                return Object.keys(j).map(function(_) { return j[_]; })
            },
            readyData(a,b){
                this.options = {
                    chart: {
                        width: "100%",
                        height: 'auto',
                        type: 'pie',
                        animations: {
                            enabled: false
                        },
                        zoom: {
                            enabled: false
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        style: {
                            colors: ['#000']
                        },
                    },
                    series: [a, b],
                    //colors: ['#ffc059','#ff6565','#ff8373','#4ad991','#00e5ff','#9c9d9e'],
                    labels: [
                        'Seguro Atual - '+this.real(a),
                        'Necessidade de Complementação - '+this.real(b)
                    ],
                    legend: {
                        position: 'right',
                        fontSize: '14px',
                        itemMargin: {
                            horizontal: 8,
                            vertical: 3
                        },
                    },
                    theme: {
                        mode: 'light',
                        palette: 'palette1'
                    },
                    tooltip:{
                        theme:'dark'
                        
                    },
                    responsive: [{
                        breakpoint: 1331,
                        options: {
                            plotOptions:{
                                pie: {
                                    size: 150,
                                    customScale: 1
                                }
                            },
                            legend: {
                                position: "bottom"
                            }
                        }
                    }]
                }
            },
            async getData(){
                let { id } = this.$route.params;

                const {data: {result: {data: resumo}}} = await get(`resumo/${id}`);

                if(resumo.necessidade_segurado != null && resumo.seguro != null){
                    this.resumo = this.jsonToObject(resumo)
                }

                const necessidade_segurado = parseFloat(this.resumo[0] ? this.resumo[0] : 0);
                const seguro = parseFloat(this.resumo[1] ? this.resumo[1] : 0);

                const seguro_atual = seguro;
                const necessidade_complementacao = necessidade_segurado - seguro_atual;


                if(resumo.necessidade_segurado != null && resumo.seguro != null){
                    this.saldo = this.real(this.total(seguro_atual, necessidade_complementacao))
                    this.db.push(resumo.necessidade_segurado, resumo.seguro)
                    this.readyData(seguro_atual, necessidade_complementacao)
                }
            
            }
        },
        mounted () {
            this.getData()
        }
    }
</script>

<style lang="css" scoped>
.graph{
    text-align: center;
}
.total{
    font-size: 12px;
}
.block{
    width: 300px;
    margin-left: 160px;
    display: contents;
}
@media (min-width: 320px) and (max-width: 480px) {
   .block{
        width: 300px;
        margin-left: 25px;
        display: block;
    } 
}
</style>


// WEBPACK FOOTER //
// src/components/graficos-simulador/NecessidadeCoberturaAtual.vue